import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as TelecallerActions from "../../store/actions/Telecaller";
import ListPagination from "../../components/Common/ListPagination";
import TelecallersList from "../../components/Telecallers/TelecallersList";
import TelecallersFormModal from "../../components/Telecallers/TelecallersFormModal";

//css
import "./TeleCaller.scss";
import { Heading } from "../../constants/assets/containers";

const TeleCaller = (props) => {
  const {
    getTelecallerProfiles,
    telecallerProfiles,
    getClustersTelecaller,
    telecallerClusters,
  } = props;
  const [modalState, setModalState] = useState("");
  const [activeId, setActiveId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const handleClick = (isPresentInLMS, id) => {
    if (isPresentInLMS) {
      setModalState("Edit");
    } else {
      setModalState("Add");
    }
    setActiveId(id);
  };

  const handleClose = () => {
    setModalState("");
  };

  //handle pagination
  const handleNavClick = (action) => {
    if (action === "prev") {
      const pageRequest = {
        page_number: currentPage - 1,
      };
      setCurrentPage(currentPage - 1);
      getTelecallerProfiles(props.activeFilters, pageRequest);
    } else {
      const pageRequest = {
        page_number: currentPage + 1,
      };
      setCurrentPage(currentPage + 1);
      getTelecallerProfiles(props.activeFilters, pageRequest);
    }
  };

  useEffect(() => {
    const pageRequest = {
      page_number: currentPage,
    };
    getTelecallerProfiles({}, pageRequest);
    if (telecallerClusters.length === 0) {
      getClustersTelecaller();
    }
  }, []);

  return (
    <section className="telecaller-profile-view container">
      <div className="mb-20">
        <Heading>Telecaller profiles</Heading>
      </div>
      <TelecallersList
        handleClick={handleClick}
        telecallersList={telecallerProfiles}
      />
      <ListPagination
        nextPage={props.nextPage}
        prevPage={props.prevPage}
        handleNavClick={handleNavClick}
      />
      {modalState && (
        <TelecallersFormModal
          clusters={telecallerClusters}
          activeId={activeId}
          modalState={modalState}
          handleClose={handleClose}
        />
      )}
    </section>
  );
};

const mapStateToProps = (state) => {
  const { Telecaller } = state;
  return {
    telecallerProfiles: Telecaller.telecallerProfiles,
    activeFilters: Telecaller.activeFilters,
    nextPage: Telecaller.nextPage,
    prevPage: Telecaller.prevPage,
    telecallerClusters: Telecaller.telecallerClusters,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getTelecallerProfiles: bindActionCreators(
      TelecallerActions.getTelecallerProfiles,
      dispatch
    ),
    getClustersTelecaller: bindActionCreators(
      TelecallerActions.getClustersTelecaller,
      dispatch
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TeleCaller);
